import { useEffect, useState } from 'react';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import ErroCarregamento, { extrairMensagemErro } from '../../components/common/ErroCarregamento';
import KpiCard from '../../components/common/KpiCard';
import BarChart from '../../components/common/BarChart';
import { formatDateTime, formatDateOnly } from '../../utils/date';
import * as auditoriaApi from '../../api/auditoria';

const OPCOES_PERIODO = [
  { value: 7, label: '7 dias' },
  { value: 30, label: '30 dias' },
  { value: 90, label: '90 dias' },
];

export default function AbaDashboardAuditoria() {
  const [dias, setDias] = useState(30);
  const [stats, setStats] = useState(null);
  const [erro, setErro] = useState('');

  const carregar = async (periodo) => {
    setErro('');
    try {
      const { data } = await auditoriaApi.obterEstatisticas(periodo);
      setStats(data);
    } catch (err) {
      setErro(extrairMensagemErro(err, 'Não foi possível carregar as estatísticas de uso.'));
    }
  };

  useEffect(() => {
    setStats(null);
    carregar(dias);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dias]);

  if (!stats) {
    return erro ? <ErroCarregamento mensagem={erro} onRetry={() => carregar(dias)} /> : <LoadingSpinner />;
  }

  const graficoPorDia = stats.por_dia.map((d) => ({ label: formatDateOnly(d.dia), valor: d.total }));
  const maiorPorDia = Math.max(1, ...stats.por_dia.map((d) => d.total));

  return (
    <div>
      <div className="filtros-painel mb-3">
        <div className="filtros-painel__linha">
          <span className="filtros-painel__label">Período</span>
          <div className="filter-tabs">
            {OPCOES_PERIODO.map((o) => (
              <button
                key={o.value}
                type="button"
                className={`filter-tab${dias === o.value ? ' is-active' : ''}`}
                onClick={() => setDias(o.value)}
              >
                {o.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="kpi-grid mb-3">
        <KpiCard icon="login" value={stats.total_logins} label={`Logins nos últimos ${stats.periodo_dias} dias`} />
        <KpiCard icon="group" value={stats.usuarios_unicos} label="Usuários únicos que acessaram" />
        <KpiCard icon="block" value={stats.total_login_falha} label="Tentativas de login falhas" />
        <KpiCard icon="history" value={stats.total_eventos} label="Eventos de auditoria no período" />
      </div>

      <div className="d-flex flex-wrap gap-3 mb-3">
        {graficoPorDia.length > 0 && (
          <div className="card-soft" style={{ padding: 24, flex: '2 1 420px' }}>
            <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--am-tinta)', marginBottom: 4 }}>
              Logins por dia
            </div>
            <p style={{ fontSize: 12, color: 'var(--am-cinza-texto-2)', margin: '0 0 4px' }}>
              Quantidade de logins bem-sucedidos por dia, no período selecionado
            </p>
            <BarChart dados={graficoPorDia} corBarra="var(--am-link)" maxValor={maiorPorDia} sufixo="" />
          </div>
        )}

        <div className="card-soft" style={{ padding: 24, flex: '1 1 320px' }}>
          <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--am-tinta)', marginBottom: 4 }}>
            Logins por usuário
          </div>
          <p style={{ fontSize: 12, color: 'var(--am-cinza-texto-2)', margin: '0 0 12px' }}>
            Quem mais acessou o sistema no período
          </p>
          {stats.por_usuario.length === 0 ? (
            <div className="empty-state">
              <div className="ms">login</div>
              <div>Nenhum login registrado neste período.</div>
            </div>
          ) : (
            <div className="d-flex flex-column gap-2">
              {stats.por_usuario.map((u) => (
                <div key={u.id_usuario || u.email} className="list-row" style={{ padding: '8px 10px' }}>
                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--am-tinta)' }}>{u.email || '—'}</div>
                    <div style={{ fontSize: 11, color: 'var(--am-cinza-texto-2)' }}>
                      {u.perfil || '—'} · último acesso {formatDateTime(u.ultimo_login)}
                    </div>
                  </div>
                  <span style={{ width: 32, textAlign: 'right', fontSize: 13, fontWeight: 700, color: 'var(--am-tinta)' }}>
                    {u.total_logins}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {stats.por_acao.length > 0 && (
        <div className="card-soft" style={{ padding: 24 }}>
          <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--am-tinta)', marginBottom: 12 }}>
            Eventos por tipo de ação
          </div>
          <div className="d-flex flex-wrap gap-2">
            {stats.por_acao.map((a) => (
              <span key={a.acao} className="pill pill-neutral">
                {a.acao} · {a.total}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
